/* eslint-disable @typescript-eslint/no-floating-promises */

import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { NotFound } from '@/pages/Common/NotFound/NotFound'
import { ErrorPage } from '@/pages/Common/Error/Error'
import { PagePublicAndPrivate } from '@/pages/Common/PagePublicAndPrivate/PagePublicAndPrivate'
import { Home } from '@/pages/Public/Home/Home'
import Sign from '@/pages/Public/Signature/Signature'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LanguageWrapper = ({ children }: { children: any }): any => {
  const { i18n } = useTranslation()
  const location = useLocation()
  const language = location.pathname.split('/')[1]

useEffect(() => {
  const storedLanguage = localStorage.getItem('language') ?? 'en'
  if (['en', 'es'].includes(language)) {
    const newLanguage = language.startsWith('es') ? 'es' : 'en'
    i18n.changeLanguage(newLanguage)
    localStorage.setItem('language', newLanguage)
  } else {
    i18n.changeLanguage(storedLanguage)
  }
}, [language, i18n])

  return <>{children}</>
}

const AppRouter = (): JSX.Element => {
  return (
    <BrowserRouter>
      <LanguageWrapper>
        <Routes>
          <Route path='/signature' element={<Sign />} />
          <Route path='/route-public-and-private' element={<PagePublicAndPrivate />} />
           <Route path='/en' element={<Navigate to='/' />} />
          <Route path='/en_US' element={<Navigate to='/' />} />
          <Route path='/es' element={<Navigate to='/' />} />
          <Route path='/es_ES' element={<Navigate to='/' />} />
					<Route path='/' element={<Home />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/error/:errorType' element={<ErrorPage />} />
        </Routes>
      </LanguageWrapper>
    </BrowserRouter>
  )
}

export default AppRouter